import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { 
  getDefaultWallets,
  RainbowKitProvider,
  darkTheme,
  connectorsForWallets,
} from '@rainbow-me/rainbowkit';
import {
  metaMaskWallet,
  trustWallet,
  okxWallet,
  coinbaseWallet,
  walletConnectWallet,
  tokenPocketWallet, // Alternatif yang populer di ekosistem BSC
  safepalWallet, // Wallet populer di ekosistem Binance
  bitgetWallet, // Added Bitget wallet
} from '@rainbow-me/rainbowkit/wallets';
import { configureChains, createConfig, WagmiConfig } from 'wagmi';
import { bsc } from 'wagmi/chains';
import { publicProvider } from 'wagmi/providers/public';
import '@rainbow-me/rainbowkit/styles.css';
import Navbar from './components/Navbar';
import ClaimPage from './pages/ClaimPage';
import SwapPage from './pages/SwapPage';
import Footer from './components/Footer';
import './App.css';

const App = () => {
  // Configure BNB chain with custom RPC
  const bnbChain = {
    ...bsc,
    rpcUrls: {
      ...bsc.rpcUrls,
      default: {
        http: ['https://bnb-mainnet.g.alchemy.com/v2/bbSQdu_8tGv4Ykcb0W9a1GEsJr3P_fYG'], // Replace with your custom RPC
      },
      public: {
        http: ['https://bnb-mainnet.g.alchemy.com/v2/bbSQdu_8tGv4Ykcb0W9a1GEsJr3P_fYG'], // Replace with your custom RPC
      },
    },
  };

  // Configure chains and providers
  const { chains, publicClient } = configureChains(
    [bnbChain],
    [publicProvider()]
  );

  const projectId = '7492de2a62f1ecff9bdfa50b37de25a8'; // Your WalletConnect Project ID

  // Custom wallet list including Bitget wallet
  const connectors = connectorsForWallets([
    {
      groupName: 'Recommended',
      wallets: [
        metaMaskWallet({ projectId, chains }),
        bitgetWallet({ projectId, chains }), // Added Bitget wallet
        trustWallet({ projectId, chains }),
        okxWallet({ projectId, chains }),
        safepalWallet({ projectId, chains }), // SafePal wallet (popular in Binance ecosystem)
        tokenPocketWallet({ projectId, chains }), // TokenPocket (popular in BSC ecosystem)
        coinbaseWallet({ appName: 'Sonus Ecosystem', chains }),
        walletConnectWallet({ projectId, chains }),
      ],
    },
  ]);

  // Create wagmi config
  const wagmiConfig = createConfig({
    autoConnect: true,
    connectors,
    publicClient
  });

  return (
    <WagmiConfig config={wagmiConfig}>
      <RainbowKitProvider 
        chains={chains} 
        theme={darkTheme({
          accentColor: '#8e44ad',
          accentColorForeground: 'white',
          borderRadius: 'medium',
          fontStack: 'system',
        })}
      >
        <Router>
          <div className="app">
            <Navbar />
            <div className="content">
              <Routes>
                <Route path="/" element={<ClaimPage />} />
                <Route path="/swap" element={<SwapPage />} />
              </Routes>
            </div>
            <Footer />
          </div>
        </Router>
      </RainbowKitProvider>
    </WagmiConfig>
  );
};

export default App;